export default {
    apiBaseUrl: 'https://zcd.api.evoove.de/v0.1',
    frontendUrl: 'https://zcd.app.evoove.de',
    wsUrl: 'wss://zcd.ws.evoove.de',
    stripeConfig: {
        publicKey: 'pk_live_51M2GU0HO5xaaHBRYU9TsrXIIso9vHaBJwtDI1AYsQ30zp3PJlfyY8EjRBfDFXNqY9iTveLQ8He4XOpKNZ4xhzsMc00N4wUZ0YT',
    },
}
